var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 84,
    viewBox: "0 0 91 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7434 0.333328H9.94848C5.4613 0.333328 0.974121 4.08333 0.974121 8.66666V21.2083C0.974121 24.2083 2.90361 26.7917 5.4613 28.25V75.3333C5.4613 79.9167 10.3972 83.6667 14.4357 83.6667H77.2562C81.2946 83.6667 86.2305 79.9167 86.2305 75.3333V28.25C88.7882 26.7917 90.7177 24.2083 90.7177 21.2083V8.66666C90.7177 4.08333 86.2305 0.333328 81.7434 0.333328ZM59.3075 50.3333H32.3844V42H59.3075V50.3333ZM81.7434 21.1667H9.94848V8.66666H81.7434V21.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.1a1fe1889c1843e8af2641e22a5e5f03.svg";
export { ForwardRef as ReactComponent };